import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { NotificationBell } from '../components/notifications/NotificationBell';

export const AdminLayout = () => {
  const { logout, user } = useAuth();
  const isSuper = user?.role === 'SUPER_ADMIN';
  return (
    <div className="foundation-shell">
      <aside className="fixed inset-y-0 left-0 w-64 overflow-y-auto bg-slate-950 p-6 text-white">
        <Link to="/admin/dashboard" className="text-xl font-black">AeroBott Admin</Link>
        <nav className="mt-8 grid gap-2 text-sm font-bold">
          <p className="mt-2 text-[10px] uppercase tracking-wide text-slate-400">Overview</p>
          <Link to="/admin/dashboard" className="hover:text-[#FF9933]">Dashboard</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Marketplace</p>
          <Link to="/admin/users" className="hover:text-[#FF9933]">Users</Link>
          <Link to="/admin/pilots" className="hover:text-[#FF9933]">Pilots</Link>
          <Link to="/admin/jobs" className="hover:text-[#FF9933]">Jobs</Link>
          <Link to="/admin/disputes-v2" className="hover:text-[#FF9933]">Disputes</Link>
          <Link to="/admin/support/tickets" className="hover:text-[#FF9933]">Support tickets</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-[#FF9933]">Revenue</p>
          <Link to="/admin/subscriptions" className="hover:text-[#FF9933]">Subscriptions</Link>
          <Link to="/admin/featured-listings" className="hover:text-[#FF9933]">Featured listings</Link>
          <Link to="/admin/boosts" className="hover:text-[#FF9933]">Quote boosts</Link>
          <Link to="/admin/ads/campaigns" className="hover:text-[#FF9933]">Ad campaigns</Link>
          <Link to="/admin/ads/analytics" className="hover:text-[#FF9933]">Ad analytics</Link>
          <Link to="/admin/portfolio-projects" className="hover:text-[#FF9933]">Portfolio projects</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Money</p>
          <Link to="/admin/payments" className="hover:text-[#FF9933]">Payments</Link>
          <Link to="/admin/escrow-ledger" className="hover:text-[#FF9933]">Escrow ledger</Link>
          <Link to="/admin/payouts" className="hover:text-[#FF9933]">Payouts</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Delivery</p>
          <Link to="/admin/deliverables" className="hover:text-[#FF9933]">Deliverables</Link>
          <Link to="/admin/revisions" className="hover:text-[#FF9933]">Revisions</Link>
          <Link to="/admin/reviews" className="hover:text-[#FF9933]">Reviews</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Platform</p>
          <Link to="/admin/cms" className="hover:text-[#FF9933]">CMS</Link>
          <Link to="/admin/site-photos" className="hover:text-[#FF9933]">Site photos 🇮🇳</Link>
          <Link to="/admin/settings" className="hover:text-[#FF9933]">Settings</Link>
          <Link to="/admin/audit-logs" className="hover:text-[#FF9933]">Audit logs</Link>
          <Link to="/admin/email-logs" className="hover:text-[#FF9933]">Email logs</Link>
          <Link to="/admin/system-alerts" className="hover:text-[#FF9933]">System alerts</Link>

          {isSuper ? (
            <>
              <p className="mt-3 text-[10px] uppercase tracking-wide text-[#FF9933]">Super admin</p>
              <Link to="/super-admin/setup" className="font-black text-[#FF9933] hover:text-white">⚙ Platform setup</Link>
              <Link to="/super-admin/admin-users" className="hover:text-[#FF9933]">Staff accounts</Link>
            </>
          ) : null}
        </nav>
        <button onClick={() => void logout()} className="mt-8 w-full rounded-xl bg-[#FF9933] px-3 py-2 text-sm font-black text-slate-950">Log out</button>
      </aside>
      <main className="ml-64 min-h-screen">
        <header className="flex items-center justify-end gap-3 border-b border-slate-200 bg-white px-8 py-3">
          <NotificationBell />
        </header>
        <div className="p-8"><Outlet /></div>
      </main>
    </div>
  );
};
